var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adminPage"},[(_vm.$route.name == 'AdminLogin')?[_c('AdminLogin')]:[_c('Navigation'),_c('router-view')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }